import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/v2/alert";
import { Button } from "@/components/ui/v2/button";
import { getCampaignEditPath } from "@/features/campaigns/utils/navigation";
import { usePermissionMatrix } from "@/lib/hooks/usePermissionMatrix";

type ArchivedSegmentBannerProps = {
  clientId: string;
  campaignId: string;
  segmentName: string;
};

export function ArchivedSegmentBanner({
  clientId,
  campaignId,
  segmentName,
}: ArchivedSegmentBannerProps) {
  const { t } = useTranslation();
  const { canEdit } = usePermissionMatrix();

  return (
    <Alert
      variant="warning"
      className="items-center has-[>svg]:grid-cols-[auto_1fr_auto]"
      data-testid="archived-segment-banner"
    >
      <AlertTriangle />
      <div>
        <AlertTitle>{t("campaigns.segmentArchived.title")}</AlertTitle>
        <AlertDescription>
          {t("campaigns.segmentArchived.description", { name: segmentName })}
        </AlertDescription>
      </div>
      {canEdit("campaigns") && (
        <Button asChild size="sm">
          <Link to={getCampaignEditPath(clientId, campaignId)}>
            {t("campaigns.segmentArchived.changeSegment")}
          </Link>
        </Button>
      )}
    </Alert>
  );
}
